module.exports = __webpack_public_path__ + "static/media/trimex_Medalladeoro panificable.f4a95846.png";